<template>
  <div>
    <div class="sec-head">
      <h2 class="sec-title">{{ c.numbers_title }}</h2>
      <v-btn color="primary" variant="flat" disabled>
        <v-icon start>mdi-plus</v-icon>{{ c.buy_number }}
        <v-chip size="x-small" color="warning" variant="flat" class="ml-2">{{ c.soon }}</v-chip>
      </v-btn>
    </div>

    <div v-if="loading" class="text-center py-10 text-medium-emphasis">{{ c.loading }}</div>
    <div v-else-if="!items.length" class="empty">{{ c.numbers_empty }}</div>
    <v-row v-else>
      <v-col v-for="(n, i) in items" :key="i" cols="12" sm="6">
        <NumberCard :item="n" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import NumberCard from "@/components/client/NumberCard.vue";
import { cc } from "@/views/client/clientCopy";
import { getToken } from "@/composables/useTokenStorage";
import { getUserOwnMsisdns } from "@/composables/useUserMsisdnsAPI";

export default defineComponent({
  name: 'MyNumbersSection',
  components: { NumberCard },
  data() { return { loading: true, items: [] }; },
  computed: { c() { return cc(); } },
  async created() { await this.load(); },
  methods: {
    async load() {
      this.loading = true;
      const resp = await getUserOwnMsisdns(getToken());
      this.items = (resp && resp.msisdns) || [];
      this.loading = false;
    },
  },
});
</script>

<style scoped>
.sec-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; flex-wrap: wrap; gap: 10px; }
.sec-title { font-size: 1.4rem; font-weight: 800; color: #1a2233; }
.empty { text-align: center; color: #5A6275; padding: 40px 0; }
</style>
